/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { createObservableDataAction, IAction, IActionInput, IAny, ICreateActionContext, IGeneric } from '@msdyn365-commerce/core';
import { GenericInput, getGenericAction } from '@msdyn365-commerce-modules/retail-actions';

import { IWarehouseLocatorStateManager } from './i-warehouse-locator-state-manager';
import { WarehouseLocatorStateManager } from './warehouse-locator-state-manager';

export function createWarehouseLocatorStateInput(result: IWarehouseLocatorStateManager): GenericInput<IWarehouseLocatorStateManager> {
    return new GenericInput<IWarehouseLocatorStateManager>('warehouseLocatorSM', result, 'IWarehouseLocatorStateManager');
}

const createWarehouseLocatorStateInputInternal = (inputData: ICreateActionContext<IGeneric<IAny>>): IActionInput => {
    return createWarehouseLocatorStateInput(new WarehouseLocatorStateManager());
};

export const getWarehouseLocatorStateDataAction = createObservableDataAction({
    action: <IAction<IWarehouseLocatorStateManager>>getGenericAction,
    input: createWarehouseLocatorStateInputInternal
});

export default getWarehouseLocatorStateDataAction;
